import type { ComponentProps } from "react";
import type { ExpressionFormFieldFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { Textarea } from "@acdc2/ui/components/textarea";
import { ExpressionPredictionButton } from "./ExpressionPredictionButton";
import {
  FormControl,
  FormField,
  FormLabel,
} from "@acdc2/ui/components/access-form";
import { ValueMissingFormMessage } from "../../ui/forms";

type Props = ComponentProps<"textarea"> & {
  fragment: ExpressionFormFieldFragment;
  onPrediction: (text: string) => void;
};

export function ExpressionFormField({
  fragment,
  onPrediction,
  ...props
}: Props) {
  const { t } = useTranslation();

  return (
    <FormField name="expression">
      <FormLabel>{t("ExpressionFormField.label")}</FormLabel>
      <FormControl asChild>
        <Textarea required rows={8} {...props} />
      </FormControl>
      <ValueMissingFormMessage />
      <ExpressionPredictionButton fragment={fragment} onAccept={onPrediction} />
    </FormField>
  );
}
